import React from 'react';
import { createIntl, createIntlCache, FormattedNumber } from 'react-intl';
import { getTemplateString } from 'common/helpers/string';
import { useAppDispatch } from 'app/hooks';
import http, { fetcher } from 'app/http';
import PageLink from 'components/PageLink/PageLink';
import { setDataLoading } from 'features/core/reducer';
// Page styles
import styles from '../../DebtOverviewPageData.module.scss';
import classNames from 'classnames';


interface Props {
  Model?: any;
  PageData?: any;
}

// TODO: Check is it proper way
const cache = createIntlCache();

// TODO: Get current language
const intl = createIntl(
  {
    locale: 'fr',
  },
  cache,
);

const PayerReviewWthoutOffer = ({ Model, PageData }: Props) => {
  const payerReviewLastMonthLabel = getTemplateString(
    PageData?.PayerReviewLastMonthLabel,
  );
  const payerReviewTermToken = Model?.PayerReviewChangePlanTerm;
  const payerReviewLastPaymentAmountToken =
    Model?.FormattedCurrencyPayerReviewLastPaymentAmount;

  const dispatch = useAppDispatch();

  const handlePayerReviewUrl = async (url: any) => {
    try {
      dispatch(setDataLoading(true));
      const response = await http.get(url)
      if (response.data) {
        setDataLoading(false);
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div data-type="Promotion" data-creative-slot="Portal-Home-Top" data-promotion-name="Payer review" >
      <div className="ReviewdPaymentPlan">
        <div className="ReviewdPaymentPlan__header">
          {PageData?.TimeToReviewPlanHeader}
        </div>
        <div className="ReviewdPaymentPlan__content">
          <div className="ReviewdPaymentPlan__title">
            <h3 className="ReviewdPaymentPlan__heading">
              <span>
                <strong>
                  {PageData?.PayerReviewGetLabel}{' '}
                  {PageData?.PayerReviewDebtFreeLabel}
                </strong>
              </span>{' '}
              {!Model?.HidePayerReviewProposedPlanTerm && 
              (<span className="ReviewdPaymentPlan__fasterbtn">
                {Model?.PayerReviewNumberOfMonths}{' '}
                {Model?.PayerReviewNumberOfMonths > 1
                  ? PageData?.MonthsFasterText
                  : PageData?.MonthFasterText}
              </span>)}
            </h3>
            <div className="ReviewdPaymentPlan__notice">
              {PageData?.PayerReviewIncreasingYourPaymentPlan}{' '}
              <strong>
                {Model?.FormattedCurrencyPayerReviewAdjustedAmountWithPercent}
              </strong>
              {PageData?.PayerReviewPerMonthLabel}
            </div>
          </div>
          <div className="ReviewdPaymentPlan__section">
            <div className={classNames("ReviewdPaymentPlan__offer",
                          Model?.HidePayerReviewProposedPlanTerm && "ReviewdPaymentPlan__offerAmountValueCenter")}>
              <div className="ReviewdPaymentPlan__label">
                {PageData?.PayerReviewYouPayLabel}
                <div className="ReviewdPaymentPlan__value">
                  {Model?.FormattedCurrencyPayerReviewChangePlanAmount}
                </div>
              </div>
              {!Model?.HidePayerReviewProposedPlanTerm &&
              <>
              <i className="ReviewdPaymentPlan__icon"></i>
              <div className="ReviewdPaymentPlan__label u-borderLsolid u-borderBold">
                {PageData?.ForLabel}
                <div className="ReviewdPaymentPlan__value u-colorTextBlue">
                  {Model?.PayerReviewChangePlanTerm} {PageData?.MonthsLabel}
                </div>
              </div>
              </>
              }
            </div>
            <button className= {classNames("ReviewdPaymentPlan__link", "Button", 
                                          "btnreviewplan",
                                          Model?.HidePayerReviewProposedPlanTerm && 
                                          "u-marginBxxsm")}
              onClick={() => { handlePayerReviewUrl(Model?.PayerReviewChangePaymentPlanUrl) }}>
              {PageData?.PayerReviewChangePlanText}</button>
            {!Model?.HidePayerReviewProposedPlanTerm && payerReviewLastMonthLabel && (
              <div
                className="ReviewdPaymentPlan__notice"
                dangerouslySetInnerHTML={{
                  __html: payerReviewLastMonthLabel
                    ? payerReviewLastMonthLabel({
                      PayerReviewTerm: payerReviewTermToken,
                      PayerReviewLastPaymentAmount:
                        payerReviewLastPaymentAmountToken,
                    })
                    : '',
                }}
              />
            )}
          </div>
          <div className="ReviewdPaymentPlan__reviewplanbtnwrapper">
            {!Model?.HidePayerReviewUpdatePayment &&(
              <>
                <p className="Text--medium u-marginTxsm u-paddingBxsm">
                  {PageData?.PayerReviewChooseAlternativeAmountLabel}
                </p>
    
                 <div className="u-paddingTxxsm u-marginBxxsm">
                  <button className="Button Button--ghost blue-border btnreviewplan"
                    onClick={() => { handlePayerReviewUrl(Model?.UpdateAmountPayerReviewWithoutOfferUrl) }}>
                    {PageData?.UpdatePaymentAmountButtonLabel}</button>
                </div> 
              </>
            )
            }
            <div className="u-center u-paddingTxxsm u-marginBxxsm">
              <strong>{PageData?.PayerReviewOrLabel}</strong>
            </div>
            <div className="u-paddingTxxsm">
              <button className="Button Button--ghost gray-border btnreviewplan"
                onClick={() => { handlePayerReviewUrl(Model?.PayerReviewDeclinedUrl) }}>
                {PageData?.KeepPlanTheSameLabel}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PayerReviewWthoutOffer;
